import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppHeader } from '../AppHeader/AppHeader';
import { AppFooter } from '../AppFooter/AppFooter';
import { AppSider } from '../AppSider/AppSider';
import { ContentWrapper } from '../AppContent/ContentWrapper';
import { StyledLayout } from './AppLayout.styles';
import { ScrollToTopButton } from 'lib/components/ScrollToTopButton/ScrollToTopButton';
import { AppBreadcrumbs } from 'app/components/AppBreadcrumbs/AppBreadcrumbs';
import { ScrollToTop } from 'lib/components/ScrollToTop/ScrollToTop';
import { AuthenticationActions } from 'app/cross-cutting-concerns/authentication/state/authenticationActions';
import { selectIsCheckingAuthentication } from 'app/cross-cutting-concerns/authentication/state/authenticationSelectors';
import { LoadingPage } from 'lib/components/LoadingPage/LoadingPage';

const { Content } = Layout;
export const AppLayout = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const isCheckingAuthentication = useSelector(selectIsCheckingAuthentication);

  const dispatch = useDispatch();

  const [isSiderCollapsed, setIsSiderCollapsed] = useState(() => {
    try {
      return localStorage.getItem('sidenav-collapsing-state') === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    dispatch(AuthenticationActions.checkAuthentication());
  }, [dispatch]);

  if (isCheckingAuthentication) {
    return <LoadingPage />;
  }

  return (
    <StyledLayout className="layout" hasSider={false}>
      <AppHeader />

      <Layout hasSider>
        <AppSider
          isCollapsed={isSiderCollapsed}
          onToggleCollapse={(val: boolean): void => {
            setIsSiderCollapsed(val);
            localStorage.setItem('sidenav-collapsing-state', String(val));
          }}
        />
        <ScrollToTop containerRef={containerRef} />
        <Layout className="layout-content">
          <Content>
            <ContentWrapper isCollapsed={isSiderCollapsed}>
              <AppBreadcrumbs />
              <Outlet />
              <AppFooter>
                <ScrollToTopButton containerRef={containerRef} />
              </AppFooter>
            </ContentWrapper>
          </Content>
        </Layout>
      </Layout>
    </StyledLayout>
  );
};
